import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPackagingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1",
		"data-name": "Layer 1",
		children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "80.82 30.09 78.83 58.4 72.15 57.37 62.17 59.44 60.67 61.21 61.96 71.41 64.85 76.71 47.26 88.87 14.9 69.92 16.25 31.01 48.41 11.11 80.82 30.09"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M28.72,40.35V38.72l1.39-.81L18.26,31l29.5-17.28,11.85,6.94,1-.58,1.71-.8L48.41,11.11a1.29,1.29,0,0,0-1.29,0L14.91,29.83a1.4,1.4,0,0,0-.7,1.21V68.71a1.41,1.41,0,0,0,.69,1.21l13.93,8.16-.11-2V74.76L17,67.9V33.49Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M84.49,59.4h0c-1.08-.51-2.09-.93-3.08-1.3V31.16a1.22,1.22,0,0,0-.37-.89.4.4,0,0,0-.12-.1l-.09-.08L68.4,22.82l-2.53,1.47L77.6,31.16,48.1,48.44,36.25,41.5l-1.4.81v1.63L46.57,50.8V85.21L34.85,78.35v3.26l12.41,7.26a1.4,1.4,0,0,0,1.41,0L65.37,79a26.63,26.63,0,0,0,6.35,5.35,2.38,2.38,0,0,0,2.52,0c4.33-2.71,7.18-5.66,9-9.31s2.56-7.75,2.56-13.6A2.35,2.35,0,0,0,84.49,59.4Zm-5.64-2.12-.09,0a24.74,24.74,0,0,0-5.71-.85h-.11a25.3,25.3,0,0,0-5.7.85,34.75,34.75,0,0,0-5.58,2.09,2.36,2.36,0,0,0-1.44,2.15c0,5.74.81,10.06,2.57,13.6a20,20,0,0,0,1,1.81L49.37,85.36V50.65L78.85,33.39ZM67.9,59.72A22.94,22.94,0,0,1,73,59a22.74,22.74,0,0,1,5.11.76L79.2,60c.5.16,1,.33,1.52.53.81.3,1.64.66,2.53,1.07,0,5.37-.73,9.17-2.31,12.33A20.4,20.4,0,0,1,73,82.16a24,24,0,0,1-5.79-4.91c-.34-.41-.66-.83-1-1.25a16.76,16.76,0,0,1-1.2-2c-1.56-3.15-2.29-7.07-2.3-12.32A31.51,31.51,0,0,1,67.9,59.72Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M63.23,19.2l-1.95-1.14a1.78,1.78,0,0,0-1.81,0L57.52,19.2a1.79,1.79,0,0,0,.91,3.34,1.77,1.77,0,0,0,.9-.25l1.05-.61,1,.61a1.8,1.8,0,0,0,1.36.18,1.75,1.75,0,0,0,1.09-.83A1.78,1.78,0,0,0,63.23,19.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M47.86,26.93a1.82,1.82,0,0,0-1.09-.83,1.85,1.85,0,0,0-1.36.19l-4,2.37a1.78,1.78,0,0,0-.64,2.45,1.8,1.8,0,0,0,1.54.88,1.82,1.82,0,0,0,.91-.24l4-2.37A1.79,1.79,0,0,0,47.86,26.93Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M55.94,22.2a1.79,1.79,0,0,0-1.1-.82,1.73,1.73,0,0,0-1.35.18l-4,2.37A1.79,1.79,0,0,0,51.26,27l4-2.37A1.79,1.79,0,0,0,55.94,22.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M39.79,31.66A1.78,1.78,0,0,0,37.34,31l-4,2.36a1.84,1.84,0,0,0-.83,1.1,1.79,1.79,0,0,0,1.74,2.24,1.7,1.7,0,0,0,.9-.25l4-2.36A1.79,1.79,0,0,0,39.79,31.66Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M28.22,42.48A1.79,1.79,0,0,0,30,40.69V39.46l1.06-.62a1.78,1.78,0,0,0,.64-2.45,1.78,1.78,0,0,0-2.45-.64l-1.94,1.14a1.79,1.79,0,0,0-.89,1.55v2.25A1.79,1.79,0,0,0,28.22,42.48Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M28.22,61.43A1.8,1.8,0,0,0,30,59.63V54.9a1.79,1.79,0,0,0-3.58,0v4.73A1.8,1.8,0,0,0,28.22,61.43Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M28.22,70.9A1.79,1.79,0,0,0,30,69.11V64.37a1.79,1.79,0,1,0-3.58,0v4.74A1.79,1.79,0,0,0,28.22,70.9Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M28.22,52A1.8,1.8,0,0,0,30,50.16V45.43a1.79,1.79,0,0,0-3.58,0v4.73A1.8,1.8,0,0,0,28.22,52Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M31.9,76.78a1.75,1.75,0,0,0-.83-1.09L30,75.07V73.84a1.79,1.79,0,1,0-3.58,0V76.1a1.81,1.81,0,0,0,.89,1.55l1.95,1.14a1.76,1.76,0,0,0,.9.24,1.79,1.79,0,0,0,1.73-2.25Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M35.36,76.22a1.79,1.79,0,0,0-1.67,1.14,1.69,1.69,0,0,0-.74,0,1.75,1.75,0,0,0-1.09.83,1.78,1.78,0,0,0,.64,2.44l2,1.14a1.83,1.83,0,0,0,.91.25,1.75,1.75,0,0,0,.89-.24,1.8,1.8,0,0,0,.9-1.55V78A1.79,1.79,0,0,0,35.36,76.22Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M35.36,47.81a1.8,1.8,0,0,0-1.8,1.79v4.73a1.8,1.8,0,0,0,3.59,0V49.6A1.79,1.79,0,0,0,35.36,47.81Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M35.36,57.28a1.8,1.8,0,0,0-1.8,1.79V63.8a1.8,1.8,0,0,0,3.59,0V59.07A1.79,1.79,0,0,0,35.36,57.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M35.36,66.75a1.8,1.8,0,0,0-1.8,1.79v4.73a1.8,1.8,0,0,0,3.59,0V68.54A1.79,1.79,0,0,0,35.36,66.75Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M36.4,39.92l-1.95,1.14a1.79,1.79,0,0,0-.89,1.54v2.26a1.8,1.8,0,0,0,3.59,0V43.63L38.21,43a1.79,1.79,0,1,0-1.81-3.09Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M44.47,35.19l-4,2.36A1.78,1.78,0,0,0,39.8,40a1.79,1.79,0,0,0,1.54.89,1.83,1.83,0,0,0,.91-.25l4-2.36a1.79,1.79,0,1,0-1.81-3.09Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M62,25.54a1.8,1.8,0,0,0-1.36.19l-4,2.36a1.79,1.79,0,0,0-.82,1.1,1.77,1.77,0,0,0,.18,1.35,1.81,1.81,0,0,0,1.55.89,1.76,1.76,0,0,0,.9-.24l4-2.37a1.79,1.79,0,0,0,.64-2.45A1.82,1.82,0,0,0,62,25.54Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M53.91,30.27a1.79,1.79,0,0,0-1.36.19l-4,2.36a1.81,1.81,0,0,0-.83,1.1,1.77,1.77,0,0,0,.19,1.35,1.78,1.78,0,0,0,2.45.64l4-2.36a1.79,1.79,0,0,0-.45-3.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M69.3,23.77h0a1.81,1.81,0,0,0-.88-1.55l-2-1.13a1.79,1.79,0,0,0-2.64,2,1.91,1.91,0,0,0,.35.68,1.8,1.8,0,0,0,2.29,2.69l2-1.14A1.82,1.82,0,0,0,69.3,23.77Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M80.8,64.7h0a1.41,1.41,0,0,0-2,0l-7.2,7.2-2.34-2.33a1.41,1.41,0,0,0-2,2l3.33,3.33a1.41,1.41,0,0,0,1,.41,1.37,1.37,0,0,0,1-.41l8.2-8.2A1.41,1.41,0,0,0,80.8,64.7Z"
			})
		]
	})
});
export default SvgPackagingSm;
